// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: "porscheday-b025f.firebaseapp.com",
    databaseURL: "https://porscheday-b025f-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "porscheday-b025f",
    storageBucket: "porscheday-b025f.appspot.com",
    messagingSenderId: "246322248431",
    appId: "1:246322248431:web:34c8b5bb43b95a786766f7",
    measurementId: "G-1KN1T7SJ47"
  };

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);